import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCredits } from "./../actions/credits";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import Button from '@material-ui/core/Button';
import { feathersCreateData } from "../services";
import Footer from '../components/Complements/Footer';
import { exportExcel } from './../functions/exportExcel'


const CreditsContainer = props => {
    const { classes, secuencial, parameters } = props
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    const [loading, setLoading] = useState(false)
    const [dateStart, setDateStart] = useState(new Date())
    const dateEnd = new Date()
    const [dateValue, setDateValue] = useState(JSON.stringify({ month: moment().month(), year: moment().year() }))
    const [dataCredits, setDataCredits] = useState([])
    const [codespaginate, setCodesPaginate] = useState([])
    const [dateEndRange, setDateEndRange] = useState(dateEnd)




    const mount = () => {
        const unmount = () => {
            try {
                moment.locale('es-es')

                handleGetCredits()

            } catch (error) {
                console.log(error)
            }

        }
        return unmount()
    }
    useEffect(() => {
        mount();
        // eslint-disable-next-line
    }, []);

    // functions
    const handleGetCredits = async () => {
        try {
            // Verificar que la consulta a la API esté funcionando correctamente
            const responseDataCredits = await feathersCreateData("core-server", {
                service: 'LOANS',
                func: 'RETURN DETAILED INFORMATION SEVERAL LOAN',
                data: {
                    SecuencialPrestamo: secuencial,
                    FechaInicial: moment(dateStart).format("YYYY-MM-DD"),
                    FechaFinal: moment(dateEnd).format("YYYY-MM-DD")
                }
            })();

            const { error, data } = responseDataCredits;
            console.log(responseDataCredits, "responseDataCredits")
            if (error) {
                const validData = Object.values(data).filter(item => {
                    // Filtrar los datos de acuerdo con DueDate
                    if (item.DueDate) {
                        const dueDate = new Date(item.DueDate.substring(0, 4), item.DueDate.substring(4, 6) - 1, item.DueDate.substring(6, 8));
                        return dueDate >= new Date(dateStart) && dueDate <= new Date(dateEnd);
                    }
                    return false;
                });

                const sortedData = validData.sort((x, y) => {
                    const a = new Date(x.DueDate);
                    const b = new Date(y.DueDate);
                    return b - a;
                });

                const newData = sortedData.map(item => ({
                    ...item,
                    fecha: moment(item.DueDate, 'YYYYMMDD').format('YYYY-MM-DD')
                }));

                // Actualizar la vista con los datos paginados
                setDataCredits(newData);
                getDataViewTable(newData);
            } else {
                setDataCredits([]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleDateStart = (date) => {
        setDateStart(date)
    }
    const handleDateEnd = (date) => {
        setDateEndRange(date)
    }

    const onChangePaginationCodes = (e, page) => {
        console.log(page)//4
        //console.log(codes)//16
        let init = (page - 1) * 5;//15
        let end = page * 5;//20
        let datacodespaginate = [];
        datacodespaginate = dataCredits.slice(init, end);
        console.log(datacodespaginate, "datacodespaginate")
        setCodesPaginate(datacodespaginate)
        setPage(page)
    }

    const getDataViewTable = (allData) => {
        let datacodespaginate = [];
        let count = parseInt((allData.length / 5).toString());
        let residuo = allData.length % 5;

        if (residuo > 0) {
            count++;
        }

        if (allData.length > 0) {
            datacodespaginate = allData.slice(0, 5);
        }
        setCodesPaginate(datacodespaginate)
        setCount(count)
        setPage(1)
    }

    const handleSelectCredits = (val) => {
        try {
            setDateValue(val)
            setLoading(true)
            if (val === 'Todos los movimientos') {
                handleGetCredits()
                setLoading(false)
            } else {
                let obj = JSON.parse(val)
                let selectMonth = new Date(obj.year, obj.month, 1)
                setDateStart(moment(selectMonth).startOf('month'))
                setDateEndRange(moment(selectMonth).endOf('month'))
                handleGetCredits()
                setLoading(false)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleFindRange = () => {
        try {

            handleGetCredits(dateStart, dateEndRange, secuencial)

        } catch (error) {
            console.log(error, "eorrrrrrrrrorrrr")
        }
    }

    const handleSubmit = (val) => {
    }

    const excel = async () => {
        let headers = ['Fecha de pago',
            '# Cuota',
            'Estado',
            'Capital',
            'Interés',
            'Otros Intereses',
            'Total Cuota',
            'saldo']
        let docName = "Movimientos de Créditos"
        let attributes = Object.values(dataCredits).map((item) => {
            item.FeeStatusId = (item.FeeStatusId === '0') ? 'Indefinido' : (item.FeeStatusId === '1') ? 'Activo' : (item.FeeStatusId === '2') ? 'Vencido' : 'Pagado'
            item.DueDate = moment(item.DueDate).format('YYYY-MM-DD')
            return item
        })
        console.log('CreditsContainer-attributes', attributes)
        let columnNames = ['DueDate', 'FeeNumber', 'FeeStatusId', 'ValueTrn' , 'InterestAmount', 'OthersAmount', 'TotalAmount', 'PrincipalAmount']
        let docType = 3
        await exportExcel(headers, attributes, docName, columnNames, docType)
    }

    //render
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />;
        }

        console.log("state.creditspaginate", dataCredits);

        if (Object.keys(codespaginate).length > 0) {

            const feeStatusMap = {
                "0": "Indefinido",
                "1": "Activo",
                "2": "Vencido",
                "3": "Pagado",
            };

            return (
                <div className={"container"}>
                    <Button
                        size="large"
                        variant="contained"
                        style={{
                            fontSize: '0.8rem',
                            color: '#FFFFFF',
                            backgroundColor: "#2E2757",
                            borderRadius: '4px',
                            fontWeight: 'bold'
                        }}
                        startIcon={<Icon>attach_file</Icon>}
                        onClick={() => excel()}
                    >
                        DESCARGAR EN EXCEL
                    </Button>

                    <br />
                    <Grid item xs={12} md={12} lg={12}>
                        <Table className={"table"}>
                            <Thead>
                                <Tr>
                                    <Th>Fecha de pago</Th>
                                    <Th># Cuota</Th>
                                    <Th>Estado</Th>
                                    <Th>Capital</Th>
                                    <Th>Interés</Th>
                                    <Th>Otros Intereses</Th>
                                    <Th>Total Cuota</Th>
                                    <Th>Saldo</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    codespaginate.map((row, index) => (
                                        <Tr key={index}>
                                            <Td>{row.fecha}</Td>
                                            <Td>{row.FeeNumber}</Td>
                                            <Td>{feeStatusMap[row.FeeStatusId]}</Td>
                                            <Td>$ {row.ValueTrn}</Td>
                                            <Td>$ {row.InterestAmount}</Td>
                                            <Td>$ {row.OthersAmount}</Td>
                                            <Td>$ {row.TotalAmount}</Td>
                                            <Td>$ {row.PrincipalAmount}</Td>
                                        </Tr>
                                    ))
                                }
                            </Tbody>
                        </Table>
                    </Grid>

                    {/* Paginación */}
                    <Pagination
                        style={{ marginTop: '5px' }}
                        count={count}
                        page={page} // De nuevo, restamos 1 porque Pagination usa un índice 0
                        onChange={onChangePaginationCodes}
                    />
                </div>
            );
        } else {
            return (
                <Alert severity="info">
                    No se han encontrado movimientos en el mes seleccionado.
                </Alert>
            );
        }
    };


    // const filteredData = Object.entries(dataCredits)
    //     .filter(([key, value]) => {
    //         if (typeof value === 'object' && value.FeeNumber) {
    //             const feeDate = moment(value.fecha, "YYYY-MM-DD"); // Parsear la fecha correctamente
    //             return feeDate.isBetween(moment(dateStart).startOf('day'), moment(dateEnd).endOf('day'), null, '[]'); // Asegurar que las fechas estén dentro del rango
    //         }
    //         return false;
    //     });

    const renderBody = () => {
        return <div style={{ padding: "20px", border: '2px solid #BEBCC0', borderRadius: "8px", /* boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'*/ }}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <Typography component="h2" variant="h6" gutterBottom style={{
                        color: "#000000",
                        fontSize: "120%"
                    }}>
                        Detalle de Créditos
                    </Typography>
                </Grid>
            </Grid>
            <SelectForm
                name={'Período'}
                label={'Seleccionar período '}
                classes={classes}
                dateValue={dateValue}
                onSelected={(val) => handleSelectCredits(val)}
                onSubmit={handleSubmit}
                parameters={parameters}
            ></SelectForm>
            <br></br>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={3} alignItems="flex-end">
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    maxDate={dateEnd}
                                    maxDateMessage="La fecha de Inicio no debe ser superior a la fecha actual"
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-start"
                                    label="Fecha de inicio"
                                    value={dateStart}
                                    onChange={handleDateStart}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>

                                <KeyboardDatePicker
                                    maxDate={dateEnd}
                                    maxDateMessage="La fecha de fin no debe ser superior a la fecha actual"
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-end"
                                    label="Fecha de fin"
                                    value={dateEnd}
                                    onChange={handleDateEnd}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                            <Fab style={{ backgroundColor: '#2E2757' }} aria-label="add" onClick={handleFindRange} >
                                <Icon style={{ color: "#FFFFFF" }}>search</Icon>
                            </Fab>
                            <Typography component="h2" variant="h6" gutterBottom style={{
                                color: "#000000",
                                fontSize: "120%"
                            }}>
                                CONSULTAR
                            </Typography>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                            <Fab style={{ backgroundColor: '#2E2757' }} aria-label="add" onClick={() => history.push('/')} >
                                <Icon style={{ color: "#FFFFFF" }}>close</Icon>
                            </Fab>
                            <Typography component="h2" variant="h6" gutterBottom style={{
                                //fontFamily: "MyriadPro-SemiBold",
                                color: "#000000",
                                fontSize: "120%"
                            }}>
                                CONSULTAR
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <br /> <br />
            <Grid container justify="center" spacing={3} alignItems="center" m={10}>
                {
                    renderTableMovements()
                }
            </Grid>
        </div>
    }
    return (
        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                multiple={false}
            />
            <Footer />
        </div>
    );
};

CreditsContainer.propTypes = {
    secuencial: PropTypes.string.isRequired,
};

export default connect(null, { getCredits })(CreditsContainer);